<template>
  <section class="card-info">
    <div class="typography-headline-6" v-if="assignedCard && assignedCard.grade_id < 7">
      {{ $t('comp.card.info.summary', { chapterPosition, chapterName }) }}
    </div>
    <div class="typography-headline-6" v-if="coreConcept">
      {{ coreConcept.name }}
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import labels from '@/mixins/labels';

export default {
  name: 'card-info',

  props: [
    'card',
  ],

  mixins: [
    labels,
  ],

  computed: {
    ...mapGetters({
      gradeMap: 'gradeMap',
      coreConcepts: 'coreConcepts',
    }),

    assignedCard() {
      return this.card && this.card.assigned_card;
    },

    gradeName() {
      return this.getTranslatedName(this.assignedCard &&
          this.gradeMap[Number(this.assignedCard.grade_id)]);
    },

    subjectName() {
      return this.assignedCard && this.assignedCard.subject_name;
    },

    publisherName() {
      return this.assignedCard && this.card.assigned_by_name;
    },

    chapterPosition() {
      return this.assignedCard && this.assignedCard.chapter_position;
    },

    chapterName() {
      return this.assignedCard && this.assignedCard.chapter_name;
    },

    coreConcept() {
      return this.assignedCard && this.coreConcepts[this.assignedCard.core_concept_id];
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-info {
    margin-bottom: 16px;
    background-color: transparent;
    border-color: transparent;
    color: #ffff;
  }
</style>
